<script setup>
</script>
<template>
  <div class="page-container new_article_design">
    <section class="blog-article-section">
      <article class="blog-article">
        <div class="container">
          <div class="single-article-wrapper">
            <div class="blog-post-date">July 12, 2024</div>
            <h1 class="article-title">
              Tools to power your trades and investments: July 2024
            </h1>
            <div class="article-cat">
              Blog |
              <a
                href="/market-talk/category/product-update/"
                rel="category tag"
                >PRODUCT UPDATE</a
              >
            </div>
            <div class="single-article-featured-img">
              <img
                width="937"
                height="534"
                src="https://upstox.com/app/uploads/2024/07/Thumbnail-9.png"
                class="secondary-thumbnail"
                alt=""
                loading="lazy"
                srcset="
                  https://upstox.com/app/uploads/2024/07/Thumbnail-9.png         937w,
                  https://upstox.com/app/uploads/2024/07/Thumbnail-9-300x171.png 300w,
                  https://upstox.com/app/uploads/2024/07/Thumbnail-9-768x438.png 768w,
                  https://upstox.com/app/uploads/2024/07/Thumbnail-9-50x28.png    50w
                "
                sizes="(max-width: 937px) 100vw, 937px"
              />
            </div>
            <div class="single-article-content">
              <p>
                <span style="font-weight: 400"
                  >With a refreshing monsoon lightening all of our moods, we are
                  here to share some interesting product updates to explore
                  while sipping your tea in the rains.</span
                >
              </p>
              <p>
                Check them out below <span style="font-weight: 400">💜</span>
              </p>
              <p>&nbsp;</p>
              <p><b>Updates on ‘Upstox for Investor’ mode</b></p>
              <p>&nbsp;</p>
              <p><b>Tax report for your Mutual Fund Holdings</b></p>
              <p>
                <span style="font-weight: 400">Easily </span
                ><span style="font-weight: 400"
                  >access Income Tax report for filing gains from your Mutual
                  Fund investments</span
                >
              </p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-49058 size-full"
                  src="https://upstox.com/app/uploads/2024/07/Tax-Report.gif"
                  alt=""
                  width="600"
                  height="680"
                />
              </p>
              <p><b>Upcoming features:</b></p>
              <p>
                <b><br /> </b><strong>Motor Insurance:</strong>
              </p>
              <p>
                <span style="font-weight: 400"
                  >Safeguard your wheels, drive safely, and drive smart. It’s
                  not just the law - it’s also recommended by us! Stay tuned for
                  Top Motor Insurance Plans on Upstox.</span
                >
              </p>
              <p>&nbsp;</p>
              <p><strong>National Pension Scheme (NPS):</strong></p>
              <p>
                <span style="font-weight: 400">Investing </span
                ><span style="font-weight: 400"
                  >₹1,50,000 in tax-saving schemes under Section 80C and want to
                  save an additional</span
                ><span style="font-weight: 400">
                  ₹50,000 from taxes?&nbsp; Stay tuned for NPS - smart for
                  retirement, saving taxes, and building wealth right.</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <b>Updates on ‘Upstox Pro for traders’ mode</b
                ><span style="font-weight: 400">:</span>
              </p>
              <p>
                <b
                  ><br />
                  1. Payoff Graph</b
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  >With Payoff Graph, analyse the probable outcome of your
                  trades. You can track metrics like profit probability, maximum
                  profit &amp; loss, required margin, etc.</span
                >
              </p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-49056 size-full"
                  src="https://upstox.com/app/uploads/2024/07/Estimated-PnL_v1.gif"
                  alt=""
                  width="600"
                  height="680"
                />
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  >2. <strong>Quick trade</strong> is now also available for
                  FINNIFTY and SENSEX indices&nbsp;</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  >Head to the links below to try these features.</span
                >
              </p>
              <p>
                <span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"
                  >The above features are only available on the new Upstox
                  app.</span
                >
              </p>
              <ul>
                <li>
                  <span style="font-weight: 400"
                    >Please download the new app if you haven’t got it yet: </span
                  ><strong
                    ><em
                      ><a
                        href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"
                        target="_blank"
                        >Download now</a
                      ></em
                    ></strong
                  >
                </li>
                <li>
                  <span style="font-weight: 400"
                    >Go to the ‘Accounts’ tab at the bottom of the screen.</span
                  >
                </li>
                <li>
                  <span style="font-weight: 400"
                    >Switch the toggle button to ‘Upstox Pro’ from the top of
                    the screen</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="download-App">
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/apple-icon.png"
                alt="apple-icon"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>iOS App</h3>
            </div>
          </a>
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/play-store-icon.png"
                alt="play-store"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>Android App</h3>
            </div>
          </a>
        </div>
      </article>
    </section>
  </div>
</template>
<style scoped>
</style>
